<template>
  <v-app  v-bind:style="stylePagina">
    <v-main  v-bind:style="stylePagina">
      <v-container fluid class="pa-0">

        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card dark>
            <v-card-title class="text-h5">
              Ingresaron tus Datos!
            </v-card-title>
            <v-card-text class="text-h6">¡Listo! ¡Se registraron tus datos!</v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <section >
          <v-row  justify="center" v-bind:style="styleMain" align="center">

            <v-col  cols="12" sm="12" md="6" lg="8" class="mt-12">
<v-row>
  <v-col cols="12">
    <img src="@/assets/vuse/VUSE_GO_Logo_Blanco.png" width="100%" />
  </v-col>
</v-row>
              <v-row  justify="center" align="center">
                <v-col cols="10" >
                  <v-carousel
                      :show-arrows="false"
                      :hide-delimiters="true"
                      :continuous="true"
                      :cycle="true"
                      height="60px"
                      :interval="700"
                      >
                    <v-carousel-item
                    src="@/assets/vuse/origami/origami-blueberry.png"
                    style="height: 50px" contain ></v-carousel-item>
                    <v-carousel-item
                        src="@/assets/vuse/origami/ORIGAMI_GRAPE.png"
                        style="height: 50px" contain ></v-carousel-item>
                    <v-carousel-item
                        src="@/assets/vuse/origami/ORIGAMI_WATERMELON.png"
                        style="height: 50px" contain ></v-carousel-item>
                  </v-carousel>
                  <img src="" width="100%" />
                </v-col>
              </v-row>
              <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
              >
                <v-row   justify="center" align="center" v-bind:style="styleForm" class="pa-12 ma-12" >
                  <v-col cols="12" >
                    Completa el formulario a continuación:
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="ma-0  pa-1">
                    <v-text-field outlined  v-bind:style="styleComponent" v-model="editedItem.nombre" :label="$t('formularios.nombres')" :rules="[rules.required]"> </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="ma-0 pa-1">
                    <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.apellidoPaterno" :label="$t('formularios.ApPaterno')" :rules="[rules.required]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" class="ma-0 pa-1">
                    <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.dni"  label="DNI" :rules="[rules.required]"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"  class="ma-0 pa-1">
                    <v-text-field outlined v-bind:style="styleComponent" v-model="editedItem.email" :label="labelEmail" :rules="emailRules" ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"  class="ma-0 pa-1">

                  <v-text-field class="ma-0" outlined v-bind:style="styleComponent" v-model="editedItem.telefono" label="Celular" :rules="[rules.required]"></v-text-field>
                  </v-col>
                  <v-col  cols="12" sm="6" md="6"  class="ma-0 pa-1">
                    <v-autocomplete class="ma-0" outlined  v-model="editedItem.distrito" :rules="[v => v.id > 0 || 'Requerido']" :items="distritos" item-value="id" item-text="distrito" persistent-hint
                                    return-object
                                    single-line :label="labelDistrito"></v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-row>

                      <v-col  cols="2" sm="2" md="2" class="mt-0 pa-1">

                    <v-checkbox
                        v-model="editedItem.aceptoCondicion"
                        :rules="[v => !!v || 'Debes aceptar para continuar']"

                        required
                        style="color: #1E3D90 !important;"
                        color="#1E3D90"
                        class="ma-0"
                    ></v-checkbox> </v-col>
                  <v-col  cols="9" sm="9" md="9" class="mt-0 pa-1"> Acepta los <a target="_blank" href="https://tunaydocs.s3.amazonaws.com/Autorizacion_Datos_Personales_BAT.pdf">Términos y Condiciones</a>
                  </v-col></v-row>

                  </v-col>


                  <v-col cols="12">
                    <v-alert
                        :value="alerterror"
                        color="red"
                        dark
                        dismissible
                        border="top"
                        transition="scale-transition"
                    >
                      {{error}}
                    </v-alert>
                    <v-btn  style="background-color: #000000 !important; width: 100%; color: white;"  @click="save">PARTICIPAR</v-btn>
                  </v-col>
                </v-row>
              </v-form>  <v-row justify="end" align="top">
                <v-col cols="4">
                  <v-img src="@/assets/vuse/GOTA_ADV.png" height="150px" contain></v-img>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </section>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/infinity.gif"

          />
        </v-overlay>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "vuse",
  title: "Vuse",
  data () {
    return {
      tagevento:'',
      alertnuevo: false,
      campoapmaterno: false,
      maximafecha: null,
      tiposdoc: [{id:0,tipoDocumento:"Escoger Tipo de Documento",pais:{id:0,activo:false,codigo:'NN',pais:'NO PAIS',importancia: 0}}, {id:1, tipoDocumento:"DNI",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}, {id:2, tipoDocumento:"Carnet Extranjeria",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}, {id:3, tipoDocumento:"Pasaporte",pais:{id:173,activo:true,codigo:'pe',importancia:5,pais:'Perú'}}],
      sexos: [{id:0,Sexo:"Escoger Sexo"}, {id:1, Sexo:"Masculino"}, {id:2, Sexo:"Femenino"}, {id:3, Sexo:"Prefiero No Decirlo"}],
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      alerterror: false,
      error:'',
      distritos:[],
      aceptotermino:false,
      rules: {
        required: value => !!value || 'Requerido.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        minimo: value => value.length >= 3 || 'Minimo 3 caracteres',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Mail invalido.'
        },
      },
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      paises:[],
      rest: false,
      overlay:false,
      campodireccion: false,
      campodistrito: false,
      campofecnac: false,
      campofoto: false,
      campoinvitado: false,
      campoizqder: false,
      camporeferido: false,
      camposexo: false,
      campotelefono: false,
      campofumador: false,
      campotipocarnet: false,
      campocondiciones:false,
      camporef1: false,
      camporef2:false,
      valid: true,
      condiciones: 'Soy Mayor de Edad',
      labelNombre:'Nombre',
      labelApellidoPaterno:'Apellido paterno',
      labelApellidoMaterno:'Apellido Materno',
      labelDNI:'Numero de Documento',
      labelDistrito: 'Distrito',
      labelTipoDocumento:'Tipo de Documento',
      labelFechaNacimiento: 'Fecha de nacimiento',
      labelEmail:'Correo Electrónico',
      labelSexo:'Género',
      labelRef1:'',
      labelRef2:'',
      titulonegocio:'',
      logoexist: false,
      logoimg : '',
      eventodisenio: {},
      stylePagina: {

        fontFamily: 'GothamBlack',
        color: 'white',
        backgroundColor:'black',

      },
      styleComponent:{
        color:'#ffffff',
      },
      styleCabecera:{
        color:'#ffffff',
      },
ciudadId:0,
      ciudades:[],
      provinciaId:0,
      provincias:[],
      paisId:0,
      styleForm:{
        color:'#FFFFFF',
        marginTop:'0px !important',
      },
      styleMain:{

      },
      btnPag: {
        backgroundColor: '#000000',
        color:'white'
      },
      tag:'',
      referido:'',
      editedItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{},
        nombre:'',
        foto:'',
        email:'',
telefono:'',
direccion:'',
sexo:{},
tipoDocumento:{},
        ref1:'',
        ref2:'',
      },
      defaultdItem:{
        fechaNacimiento:null,
        apPaterno:'',
        apMaterno:'',
        dni:'',
        distrito:{id:0, distrito:''},
        nombre:'',
        foto:'',
        email:'',
        telefono:'',
        direccion:'',
        sexo:{},
        tipoDocumento:{},
        ref1:'',
        ref2:'',
      }
    }
  },
  created () {
    this.$vuetify.theme.dark = true
  },

  watch: {
    date () {
      this.editedItem.fechaNacimiento = this.formatDatee(this.date)
    }
  },
  mounted () {
    this.tagevento =  'vuse-6-abr-10-abr';
    this.damedisenio();
    this.damedistritos();
    this.date = moment(this.date).year(moment(this.date).year()-18).locale('es-pe').format("YYYY-MM-DD")
    this.maximafecha = this.date
  },
  methods: {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    scrollToCuerpo(){
      const el = this.$refs.cuerpo2;

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
     verEdad() {
       this.editedItem.fechaNacimiento.replace("/","-")
       let diff = new Date().getUTCFullYear() -  new Date(this.editedItem.fechaNacimiento).getUTCFullYear();

       return diff;

},
    scrollToCabecera(){
      const el = this.$refs.cuerpo;

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    formatDateRe(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    dameprovincias(){
      axios
          .get('provincias/pais/46')
          .then(response => {
            this.provincias = response.data;
            this.dameciudades()

          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameciudades(){
      this.progr = true;
      axios
          .get('ciudades/provincia/33')
          .then(response => {
            this.ciudades = response.data;
            this.damedistritos()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/129')
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    save(){
      this.valid = this.$refs.form.validate()

      if(this.valid){


          var bodyFormData = new FormData();
          this.overlay = true;
          this.editedItem.fechaNacimiento = this.formatDateRe(this.editedItem.fechaNacimiento)

          if(this.editedItem.fechaNacimiento === "Fecha inválida"){
            this.editedItem.fechaNacimiento = "01-01-1995"
          }
          this.editedItem.tipoDocumento = this.tiposdoc.find(x => x.id === 1)
          let eevve = 32
          bodyFormData.append("estadoEventoId",eevve)
          bodyFormData.append("persona",JSON.stringify(this.editedItem))
          bodyFormData.append("tagevento",this.tagevento)
          this.rest = true
          axios
              .post('tickets/grabar/formulario',bodyFormData)
              .then(response => {
                let ticketMin = response.data;
                console.log(ticketMin)
                this.editedItem = this.defaultdItem
                this.alertnuevo = true
                this.rest = false
                this.overlay = false
                this.valid = true
                this.$refs.form.resetValidation()
              })
              .catch((error)  => {
                console.log(error);
                this.overlay = false
              });
      }

    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    damedisenio(){
      axios
          .get('disenio/evento/'+this.tagevento)
          .then(response => {
            this.eventodisenio = response.data;
            console.log(this.eventodisenio);
            this.campoapmaterno= this.eventodisenio.campoapmaterno;
            this.labelApellidoMaterno = this.eventodisenio.labelApmaterno;
            this.labelApellidoPaterno = this.eventodisenio.labelAppaterno;
            this.campotelefono = this.eventodisenio.campotelefono;
            this.campoinvitado = this.eventodisenio.campoinvitado;
            this.camposexo = this.eventodisenio.camposexo;
            this.campodireccion = this.eventodisenio.campodireccion;
            this.campodistrito = this.eventodisenio.campodistrito;
            this.campofecnac  = this.eventodisenio.campofecnac;
            this.campofumador = this.eventodisenio.campofumador;
            this.logoexist = this.eventodisenio.logoCargado;
            this.logoimg = this.eventodisenio.logo;
            this.stylePagina.color = this.eventodisenio.colorText;
            this.btnPag.color = this.eventodisenio.colorTextBotn;
            this.btnPag.backgroundColor = this.eventodisenio.colorBgBoton;
            this.labelRef1 = this.eventodisenio.labelRef1;
            this.labelRef2 = this.eventodisenio.labelRef2;
            this.camporef1 = this.eventodisenio.camporef1;
            this.camporef2 = this.eventodisenio.camporef2;
            this.styleMain.backgroundSize = "cover";
            this.stylePagina.backgroundImage = "url('"+this.eventodisenio.backgroundImage+"')";

            this.styleCabecera.backgroundColor = this.eventodisenio.backCabeceraColor;
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: white;
}
.theme--light.v-label {
  color: white !important;
}
.v-input .v-label {
  color: white !important;

}

</style>
